import { setFetchStartState, setPartialFetchStartState } from '../fetchLoadable';
import * as actionTypes from './actionTypes';
export const caseVouchersListReducer = (state = {}, action) => {
    var _a, _b, _c;
    const { type } = action;
    const payload = action.payload || {};
    const hashedFilter = (_a = JSON.stringify(payload.query)) !== null && _a !== void 0 ? _a : '';
    const caseList = state[hashedFilter];
    switch (type) {
        case actionTypes.FETCH_MULTIPLE_CASE_VOUCHERS_START: {
            return Object.assign(Object.assign({}, state), { [hashedFilter]: Object.assign({}, setPartialFetchStartState(state[hashedFilter], payload.res, 'caseVouchers')) });
        }
        case actionTypes.FETCH_MULTIPLE_CASE_VOUCHERS_SUCCESS: {
            const newCaseVouchers = payload.reload
                ? payload.res.data.items
                : // @ts-ignore
                    [...(((_b = caseList === null || caseList === void 0 ? void 0 : caseList.data) === null || _b === void 0 ? void 0 : _b.caseVouchers) || []), ...payload.res.data.items];
            const caseVouchers = newCaseVouchers.filter((caseVoucher, i) => newCaseVouchers.findIndex((cv) => cv.caseVoucherId === caseVoucher.caseVoucherId) === i);
            return Object.assign(Object.assign({}, state), { [hashedFilter]: {
                    loadingState: payload.res.loadingState,
                    data: {
                        reachedMax: payload.res.data.items.length < payload.pagination.limit,
                        from: payload.reload
                            ? 0
                            : // @ts-ignore
                                (((_c = caseList === null || caseList === void 0 ? void 0 : caseList.data) === null || _c === void 0 ? void 0 : _c.from) || 0) + payload.pagination.limit,
                        caseVouchers,
                    },
                } });
        }
        case actionTypes.FETCH_MULTIPLE_CASE_VOUCHERS_ERROR: {
            return Object.assign(Object.assign({}, state), { [hashedFilter]: Object.assign({}, payload.res) });
        }
        default: {
            return state;
        }
    }
};
export const caseVouchersReducer = (state = {}, action) => {
    const { type, payload = {} } = action;
    switch (type) {
        case actionTypes.FETCH_CASE_VOUCHERS_BY_CASE_ID_START: {
            return Object.assign(Object.assign({}, state), { [payload.caseId]: setFetchStartState(state[payload.caseId], payload.res) });
        }
        case actionTypes.FETCH_CASE_VOUCHERS_BY_CASE_ID_ERROR: {
            return Object.assign(Object.assign({}, state), { [payload.caseId]: payload.res });
        }
        case actionTypes.FETCH_CASE_VOUCHERS_BY_CASE_ID_SUCCESS: {
            return Object.assign(Object.assign({}, state), { [payload.caseId]: payload.res });
        }
        default: {
            return state;
        }
    }
};
//# sourceMappingURL=reducer.js.map